import { createSingleRecordReadOnlyApi } from '@skylabs-digital/react-proto-kit';
import { metricsTimelineSchema } from '../schemas/metricsTimeline.schema';

export type { MetricsTimeline, TimelineDataPoint } from '../schemas/metricsTimeline.schema';

export const metricsTimelineApi = createSingleRecordReadOnlyApi(
  'metrics/timeline',
  metricsTimelineSchema,
);
